import { CALL_API } from '../middleware/api';

export const FETCHING_RETAINER_HEALTH_REPORT = Symbol('FETCHING_RETAINER_HEALTH_REPORT');
export const FETCHING_RETAINER_HEALTH_REPORT_SUCCESS = Symbol('FETCHING_RETAINER_HEALTH_REPORT_SUCCESS');
export const FETCHING_RETAINER_HEALTH_REPORT_FAILURE = Symbol('FETCHING_RETAINER_HEALTH_REPORT_FAILURE');

/**
 * Get retainer health data.
 *
 * @param {object} query Query.
 */
export function getRetainerHealth({ query }) {
  return {
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/reports/retainer_health',
      query,
      startType: FETCHING_RETAINER_HEALTH_REPORT,
      successType: FETCHING_RETAINER_HEALTH_REPORT_SUCCESS,
      errorType: FETCHING_RETAINER_HEALTH_REPORT_FAILURE,
    },
  };
}
